export const updateSetting = (update) =>
    ({
        type    : 'UPDATE_POLL_SETTING',
        payload : update
    });
export const bulkUpdateSettings = (updates) =>
    ({
        type    : 'BULK_UPDATE_POLL_SETTINGS',
        payload : updates
    });